export default __webpack_public_path__ + "static/Waste-Connections-84ddbd53d7b62dc9dc4811dacae80055.webp";